import React from 'react';

export const defaultScreenInfo = {
  accessToken: null,
  locationId: null,
  screenId: null,
  groupId: null,
  name: '',
  orientation: null,
  timeZone: '',
};

export const defaultAppState = {
  tid: null,
  localData: {
    error: null,
    isAuthenticated: false,
    token: '',
    user: '',
    config: {
      businessName: '',
      logo: '',
      logoFile: null,
      placeholderHorizontal: '',
      placeholderHorizontalFile: null,
      placeholderVertical: '',
      placeholderVerticalFile: null,
    },
  },
  screenInfo: defaultScreenInfo,
  screenMeta: null,
};

export const AppStateContext = React.createContext({
  appState: defaultAppState,
  setAppState: () => {},
});
